import { Injectable } from '@angular/core';

export const CONFIRM_DIALOG_SERVICE = 'confirmDialogService';

export interface ConfirmDialogHost {
    open(message: string, opts?: ConfirmOptions): Promise<boolean>;
}
export interface ConfirmOptions {
    title?: string;
    confirmLabel?: string;
    cancelLabel?: string;
}

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
    private host?: ConfirmDialogHost;

    register(host: ConfirmDialogHost): void {
        this.host = host;
    }

    confirm(message: string, opts?: ConfirmOptions): Promise<boolean> {
        if (!this.host) {
            console.warn('ConfirmDialog not mounted — destructive action blocked');
            return Promise.resolve(false);
        }
        return this.host.open(message, opts);
    }
}